import styled, { css } from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  spacing
} from '../../../theme';

export const StyledFeature = styled.div<{ reverse?: boolean }>`
  max-width: ${container('xl')};
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('xl')};
  padding: ${spacing('xl4')} ${spacing('md')};

  ${({ reverse }) =>
    reverse &&
    css`
      flex-direction: column-reverse;
    `}

  @media (min-width: ${container('md')}) {
    flex-direction: row;
    align-items: flex-start;

    ${({ reverse }) =>
      reverse &&
      css`
        flex-direction: row-reverse;
      `}
  }
`;

export const StyledFeatureImage = styled.div`
  flex-basis: 50%;
`;

export const StyledFeatureContent = styled.div`
  flex-basis: 50%;
  font-size: ${fontSize('lg')};
  line-height: 1.6;
`;

export const StyledFeatureAction = styled.div`
  margin-top: ${spacing('xl')};
`;

export const StyledFeatureTelegramTitle = styled.div`
  text-transform: uppercase;
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('md')};
  color: ${color('text_subtle')};
  margin-bottom: ${spacing('lg')};
`;
